import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowLeft, Receipt } from "@phosphor-icons/react";
import { getBackUrl, clearBackUrl } from "@/shared/auth/pendingCart";

/** Sticky cart summary card with the "Finalizar Encomenda" CTA. */
export default function CartSummaryCard({ total, currency, fmt, itemCount, disabled = false, grossTotal, discount = 0, discountLabel }) {
  const navigate = useNavigate();
  const backUrl = getBackUrl();
  const hasDiscount = Number(discount) > 0;

  const goBackShop = () => {
    if (!backUrl) return;
    clearBackUrl();
    window.location.href = backUrl;
  };

  return (
    <aside className="lg:sticky lg:top-6 h-fit" data-testid="cart-summary">
      <div className="bg-white rounded-xl border border-[#E5E7EB] p-5 shadow-sm">
        <h2 className="text-lg font-black tracking-tighter text-[#0F1829] mb-4 flex items-center gap-2" style={{ fontFamily: "'Fraunces', sans-serif" }}>
          <Receipt size={20} />
          Resumo
        </h2>

        <div className="space-y-3 text-sm">
          <div className="flex justify-between text-[#6B7280]">
            <span>Itens no carrinho</span>
            <span className="font-medium text-[#0F1829]">{itemCount}</span>
          </div>

          <div className="pt-3 border-t border-[#E5E7EB] flex justify-between">
            <span className="text-[#6B7280]">Subtotal</span>
            <span className="text-[#0F1829] font-semibold" data-testid="cart-subtotal">{fmt(hasDiscount ? grossTotal : total, currency)}</span>
          </div>

          {hasDiscount && (
            <div className="flex justify-between items-center" data-testid="cart-blackmonth-discount">
              <span className="text-[#059669] font-medium flex items-center gap-1.5">
                🎁 {discountLabel || "Black Month — 4 paga 3"}
              </span>
              <span className="text-[#059669] font-semibold">- {fmt(discount, currency)}</span>
            </div>
          )}

          {hasDiscount && (
            <div className="pt-3 border-t border-[#E5E7EB] flex justify-between items-baseline">
              <span className="text-[#6B7280]">Total</span>
              <span className="text-xl font-bold text-[#0F1829]" data-testid="cart-total">{fmt(total, currency)}</span>
            </div>
          )}

          <p className="text-[11px] text-[#9CA3AF] leading-relaxed">
            Os portes de envio, descontos e IVA são calculados na próxima etapa (Checkout).
          </p>
        </div>

        <button type="button" disabled={disabled || itemCount === 0}
          onClick={() => navigate("/my/checkout")}
          data-testid="cart-checkout-btn"
          className="mt-5 w-full py-3 bg-[#0F1829] hover:bg-[#002480] text-white rounded-lg text-sm font-semibold flex items-center justify-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98]">
          Finalizar encomenda
          <ArrowRight size={16} />
        </button>

        {backUrl ? (
          <button type="button" onClick={goBackShop}
            data-testid="cart-continue-shopping-btn"
            className="mt-3 w-full py-3 bg-white border-2 border-[#0F1829] text-[#0F1829] hover:bg-[#F3F4F6] rounded-lg text-sm font-semibold flex items-center justify-center gap-2 transition-colors active:scale-[0.98]">
            <ArrowLeft size={16} />
            Continuar a comprar
          </button>
        ) : null}
      </div>
    </aside>
  );
}

